import { computed, type Ref, unref } from "vue";
import { questionToPhraseStep } from "@/utils/constants";
import type { SubSectionKey, RouteKey, SectionKey, OtherRouteKey } from "@/types/questions";
import { useRoute } from "vue-router";

export function usePhraseTranslationShortcuts(subSection?: Ref<SubSectionKey> | SubSectionKey) {
  const route = useRoute();

  const phraseNrByRouteName = computed<string>(() => {
    return questionToPhraseStep[route.name as Exclude<RouteKey, SectionKey | OtherRouteKey>];
  });

  const phraseBySubSection = computed<string>(() => {
    return questionToPhraseStep[unref(subSection!)];
  });

  return { phraseNrByRouteName, phraseBySubSection };
}
